import { parseImportTemporal } from "@/utils/importTemporal"

/** Parse Firestore-style, ISO, unix, clock times, and Date values for table cells and filters. */
export function parseTableTimestamp(value: unknown): Date | null {
  if (value === null || value === undefined) return null

  if (value && typeof value === "object" && "seconds" in (value as object)) {
    const s = (value as { seconds: number }).seconds
    return new Date(s * 1000)
  }

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value
  }

  if (typeof value === "string" && value.trim() !== "") {
    return parseImportTemporal(value)
  }

  if (typeof value === "number" && !isNaN(value)) {
    return parseImportTemporal(value)
  }

  return null
}
